<ng-container *ngIf="status !== null">
  <div class="user-status" [ngSwitch]="status">

    <ng-container *ngSwitchCase="userStatus.Online">
      <span class="user-status-online">
        <mat-icon
          matTooltip="Idle - Not playing currently"
          [matTooltipPosition]="'above'"
          [svgIcon]="'round_check'"
        ></mat-icon>
      </span>
    </ng-container>

    <ng-container *ngSwitchCase="userStatus.Playing">
      <span class="user-status-online">
        <mat-icon
          matTooltip="Online - Playing"
          [matTooltipPosition]="'above'"
          [svgIcon]="'play_circle'"
        ></mat-icon>
      </span>
    </ng-container>

    <ng-container *ngSwitchCase="userStatus.Offline">
      <span class="user-status-offline">
        <mat-icon
          matTooltip="Offline - Not Connected"
          [matTooltipPosition]="'above'"
          [svgIcon]="'round_cancel'"
        ></mat-icon>
      </span>
    </ng-container>

    <ng-container *ngSwitchCase="userStatus.Unreachable">
      <span class="d-inline-block pt-1">
        <span
          matTooltip="Processing"
          [matTooltipPosition]="'above'"
          class="user-status-unreachable"
        >
        </span>
      </span>
    </ng-container>

  </div>
</ng-container>
